module.exports = __webpack_public_path__ + "img/사회활동참여.f901fdc5.png";